/** @module blank CVM・2023年リニューアルLP以外のLPで共通利用するスクリプト */
// 旧スライド式LPで全体的にjQueryを使用しているため、グローバル変数にjQueryを設定する
// 例：app/javascript/javascripts/efo/slide/section5.vue
import $ from 'jquery';
if(!globalThis.$) globalThis.$ = $;
if(!globalThis.jQuery) globalThis.jQuery = $;
